'use client';

import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import {breakpoints} from "@/styles/sizes";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

    @media only screen and (${breakpoints.mobile}) {
        height: 450px;
    }
`;

const StyledImage = styled(Image)`
  object-fit: cover;
  z-index: 1;
`;

const BackgroundImage = ({
                             src,
                             alt = 'BackgroundImage',
                             children,
                             className,
                             imageStyle,
                             overlayStyle,
                             priority = true,
                             quality = 75,
                         }) => {
    return (
        <Wrapper className={className}>
            <StyledImage
                src={src}
                alt={alt}
                fill
                priority={priority}
                quality={quality}
                sizes="100vw"
                style={imageStyle}
            />
            {children}
        </Wrapper>
    );
};

export default BackgroundImage;
